import React, { memo } from 'react'

import { classnames, ClosingDropdown, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, string, bool, func, number } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function Dropdown({
  content,
  icon,
  className = '',
  contentClassName = '',
  placement = 'bottom-end',
  triggerCloseDropdown = false,
  setTriggerCloseDropdown = NOOP,
  onOpenChange = NOOP,
  portalZIndex = undefined,
}) {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <ClosingDropdown
        content={content}
        isSimpleContent
        isSpaced
        size="medium"
        placement={placement}
        contentClassName={classnames('sidebar__dropdown-content', contentClassName)}
        withBackdrop
        className={className}
        usePortal
        triggerCloseDropdown={triggerCloseDropdown}
        setTriggerCloseDropdown={setTriggerCloseDropdown}
        onOpenChange={onOpenChange}
        portalZIndex={portalZIndex}
      >
        <Button
          type="ghost"
          variant="only-icon"
          size="tiny"
          icon={icon}
        />
      </ClosingDropdown>
    </div>
  )
}

Dropdown.propTypes = {
  content: node.isRequired,
  icon: node.isRequired,
  className: string,
  contentClassName: string,
  placement: string,
  triggerCloseDropdown: bool,
  setTriggerCloseDropdown: func,
  onOpenChange: func,
  portalZIndex: number,
}

export default memo(Dropdown)
